import React from "react";
import { Fragment } from "react";
import { connect } from "react-redux";
import { Link, useParams } from "react-router-dom";
import {
  Row,
  Col,
  Card,
  CardBody,
  CardTitle,
  Badge,
  FormGroup,
  Label,
  Table
} from "reactstrap";
import {
  closeEditOrganisationModal,
  getOrganisationDetails,
  openEditOrganisationModal
} from "../../store/organisationDetails/actions";
import Skeleton from "../../components/vwSkeleton/vwSkeleton"
import VWModel from "../../components/vwModal/vwModal";
import { useEffect } from "react";
import EditOrganisation from "./EditOrganisation";
import Message from "../../CommonData/Data/Message";
import VWLoading from "../../components/vwLoading/vwLoading";
import moment from "moment";

const OrganisationDetails = (props) => {

  const { isGetOrganisatonDetailsPending, organisationDetails, isEditOrganisationModalOpen, errorMessage } = props;
  // const params = useParams();
  // const { id } = params;
  const queryString = window.location.pathname;
  const urlParams = queryString && queryString.split("/");
  const id = urlParams && urlParams[3];

  useEffect(() => {
    props.getOrganisationDetails(id);
  }, [props.getOrganisationDetails, id]);


  const handleCloseEditOrganisationModal = () => {
    const { closeEditOrganisationModal } = props;
    closeEditOrganisationModal();
  };

  const handleOpenEditOrganisationModal = () => {
    const { openEditOrganisationModal } = props;
    openEditOrganisationModal();
  };


  return (
    <Fragment>
      {/* <ContentWrapper> */}
      <div className="page-content">
        <div className="ml-auto">
          <Card>
            <CardTitle className="mb-0 p-2 d-flex justify-content-between align-items-center fs-5 text-dark fw-bold">
              ORGANIZATION DETAILS
              <Link
                type="button"
                className="mr-1 btn btn-primary btn-sm px-2"
                onClick={handleOpenEditOrganisationModal}
              >
                <em className="far fa-edit me-2"></em>Edit Organization
              </Link>
            </CardTitle>
          </Card>
        </div>
        {errorMessage && (
          <Message
            type="danger"
            defaultMessage={errorMessage}
            baseClassName="alert"
          />
        )}
        {isGetOrganisatonDetailsPending ? (
          <div className="d-flex justify-content-center align-items-center" style={{ height: "400px" }}>
            <Skeleton type="base" />
            <VWLoading height={40} width={40} />
          </div>
        ) : (
          organisationDetails && (
            <Row>
              <Col xl="12">
                <Card>
                  <CardTitle className=' py-2 mx-4 pe-4 d-flex justify-content-between align-items-center border-bottom border-secondary'>
                    <h5 className="m-0 fw-bold">
                      <span>{organisationDetails.name}</span>
                    </h5>
                    <div className="float-right">
                      {organisationDetails.active ? (
                        <Badge color='success' className='p-2 fs-6 fw-bold'>Active</Badge>
                      ) : (
                        <Badge color='danger' className='p-2 fs-6 fw-bold'>Inactive</Badge>
                      )}
                    </div>
                  </CardTitle>
                  <CardBody className='border-bottom border-secondary mx-4'>
                    <Row className="justify-content-center">
                      <Col>
                        <Row className="text-center">
                          <Col>
                            <p className="fw-bold">USERS</p>
                            <div className="fs-4 m-0">
                              {organisationDetails.userCount || "0"}
                            </div>
                          </Col>
                          <Col>
                            <p className="fw-bold">DEVICES</p>
                            <div className="fs-4 m-0">
                              {organisationDetails.deviceCount || "0"}
                            </div>
                          </Col>
                        </Row>
                      </Col>
                    </Row>
                  </CardBody>
                  <CardBody className="py-0">
                    <h5 className="pt-3 fw-bold mb-0">API INFO</h5>
                    {organisationDetails?.apiInfo ?
                      <Row className="gx-1">
                        <Col xl={6} md={6} sm={12}>
                          <Table >
                            <tbody >
                              <tr>
                                <td className="fw-bold text-nowrap">API Access</td>
                                <td className="text-wrap">{
                                  organisationDetails.isEnableApiAccess ?
                                    <Badge color="success">Enabled</Badge> :
                                    <Badge color="danger">Disabled</Badge>
                                }
                                </td>
                              </tr>
                              <tr>
                                <td className="fw-bold text-nowrap">Created On</td>
                                <td>{organisationDetails?.apiInfo?.authKeyCreatedDateTime ? moment(organisationDetails?.apiInfo?.authKeyCreatedDateTime).format("DD MMM YYYY") : "N/A"}</td>
                              </tr>
                              <tr>
                                <td className="fw-bold text-nowrap">Created By</td>
                                <td>{organisationDetails?.apiInfo?.authKeyCreatedBy}</td>
                              </tr>
                            </tbody>
                          </Table>
                        </Col>
                        <Col xl={6} md={6} sm={12}>
                          <Table>
                            <tbody>
                              <tr>
                                <td className="fw-bold text-nowrap">Auth Key</td>
                                <td className="text-wrap" style={{ wordBreak: "break-word" }}>{organisationDetails?.apiInfo?.authKey}</td>
                              </tr>
                              <tr>
                                <td className="fw-bold text-nowrap">Updated On</td>
                                <td>{organisationDetails?.apiInfo?.authKeyUpdatedDateTime ? moment(organisationDetails?.apiInfo?.authKeyUpdatedDateTime).format("DD MMM YYYY") : "N/A"}</td>
                              </tr>
                              <tr>
                                <td className="fw-bold text-nowrap">Updated By</td>
                                <td>{organisationDetails?.apiInfo?.authKeyUpdatedBy}</td>
                              </tr>
                            </tbody>
                          </Table>
                        </Col>
                      </Row>
                      :
                      <div className="d-flex align-items-center gap-2 mt-3">
                        <div className="fs-6 fw-bold">API Access - </div>
                        {organisationDetails.isEnableApiAccess ? <Badge color="success">Enabled</Badge> : <Badge color="danger">Disabled</Badge>}
                      </div>
                    }
                  </CardBody>
                  <CardBody>
                    <Row className="pb-3">
                      <h5 className=" fw-bold mb-0">APPLICATION INFO</h5>
                      <small className="text-muted subheader text-sm mt-0 mb-2">
                        Application logo and application name was show based on user's organization. Here you can saw the organization's application logo and application name.
                      </small>
                      <Col md={6}>
                        <div>
                          <div className="fw-bold fs-5">Application Logo &nbsp;</div>
                        </div>
                        <div>
                          {organisationDetails.applicationLogo ?
                            <img src={organisationDetails.applicationLogo} alt="logo" style={{ width: 'auto', height: "100px" }} />
                            : "NA"
                          }
                        </div>
                      </Col>
                      <Col md={6} className='d-grid'>
                        <div>
                          <div className="fw-bold fs-5"> Application Name &nbsp;</div>
                        </div>
                        <div>
                          {organisationDetails.applicationName ?
                            <Badge className='p-2 fs-5' color='info'>{organisationDetails.applicationName}</Badge>
                            : "NA"
                          }
                        </div>
                      </Col>
                    </Row>
                    <Row className="pb-3">
                      <h5 className=" fw-bold mb-0">MOBILE APPLICATION INFO</h5>
                      <small className="text-muted subheader text-sm mt-0 mb-2">
                        We offer a mobile app called 'Only Switch' that allows you to control the device. Here, you can also view access details for this organization.
                      </small>
                      <Col md={6}>
                        <div>
                          <div className="fw-bold fs-5">Mobile App Permission &nbsp;</div>
                        </div>
                        <div>
                          {organisationDetails.isEnableOnlySwitchMobileApp ?
                            <Badge color="success">Enabled</Badge> :
                            <Badge color="danger">Disabled</Badge>}
                        </div>
                      </Col>
                    </Row>
                    <Row>
                      <Col md="6">
                        <Row>
                          <Col md={12}>
                            <h5 className="fw-bold">DESCRIPTION</h5>
                            <small className="text-muted subheader text-sm">
                              Here you can say about the organization and
                              services offered in more detail.
                            </small>
                          </Col>
                        </Row>
                        <Row className="pt-3">
                          <Col sm={10}>
                            <div className="form-group mb-0">
                              <Row>
                                <Col md={12}>
                                  <h6>
                                    {!organisationDetails.description ? "Not provided" : organisationDetails.description}
                                  </h6>
                                </Col>
                              </Row>
                            </div>
                          </Col>
                        </Row>
                      </Col>
                      <Col md="6">
                        <Row>
                          <Col md={12}>
                            <h5 className="fw-bold">ORGANIZATION TYPE</h5>
                            <small className="text-muted subheader text-sm">
                              Organization type refers to the purpose of the organization.
                            </small>
                          </Col>
                        </Row>
                        <Row className="pt-3">
                          <Col sm={10}>
                            <div className="form-group mb-0">
                              <Row>
                                <Col md={12}>
                                  <h6 className="text-capitalize">
                                    {(organisationDetails && organisationDetails.orgType) || "NA"}
                                  </h6>
                                </Col>
                              </Row>
                            </div>
                          </Col>
                        </Row>
                      </Col>
                    </Row>
                    <Row className="pb-3">
                      <h5 className="pt-3 fw-bold">PERMISSION</h5>
                      <Col md={6}>
                        <div className="d-flex align-items-center">
                          <div className="fw-bold">Customer Approval Status - &nbsp;</div>
                          {organisationDetails.approveNewCustomer ?
                            <Badge color="success">Enabled</Badge> :
                            <Badge color="danger">Disabled</Badge>}<br ></br>
                        </div>
                        <small className="text-muted subheader text-sm">
                          Customer need permission from organization admin for enable their account.
                        </small>
                      </Col>
                      <Col md={6}>
                        <div className="d-flex align-items-center">
                          <div className="fw-bold">  Self-Registration Status - &nbsp;</div>
                          {organisationDetails.allowCustomerSelfRegistration ?
                            <Badge color="success">Enabled</Badge> :
                            <Badge color="danger">Disabled</Badge>}<br ></br>
                        </div>
                        <small className="text-muted subheader text-sm">
                          Customers can sign up themselves.
                        </small>
                      </Col>
                      <Col md={6} className="mt-3">
                        <div className="d-flex align-items-center">
                          <div className="fw-bold">  Customer's Notification Status - &nbsp;</div>
                          {organisationDetails.enableUserMailNotification ?
                            <Badge color="success">Enabled</Badge> :
                            <Badge color="danger">Disabled</Badge>}<br ></br>
                        </div>
                        <small className="text-muted subheader text-sm">
                          Customers can get emails for enable account, reset password and etc..
                        </small>
                      </Col>
                      <Col md={6} className="mt-3">
                        <div className="d-flex align-items-center">
                          <div className="fw-bold">  Device Return Without Approval Status - &nbsp;</div>
                          {organisationDetails.isReturnApproval ?
                            <Badge color="success">Enabled</Badge> :
                            <Badge color="danger">Disabled</Badge>}<br ></br>
                        </div>
                        <small className="text-muted subheader text-sm">
                          user can return devices without waiting for approvals. It directly assigned to their higher role users.
                        </small>
                      </Col>
                      <Col md={6} className="mt-3">
                        <div className="d-flex align-items-center">
                          <div className="fw-bold">  Device Assignment Status - &nbsp;</div>
                          {organisationDetails.enableDeviceAssignment ?
                            <Badge color="success">Enabled</Badge> :
                            <Badge color="danger">Disabled</Badge>}<br ></br>
                        </div>
                        {/* <small className="text-muted subheader text-sm">
                          If it's enabled, other's can't assign devices to this organization. Also themselves can't assign devices.
                        </small> */}
                      </Col>
                      <Col md={6} className="mt-3">
                        <div className="d-flex align-items-center">
                          <div className="fw-bold">  Org User login Status - &nbsp;</div>
                          {organisationDetails.enableOrgUserLogin ?
                            <Badge color="success">Enabled</Badge> :
                            <Badge color="danger">Disabled</Badge>}<br ></br>
                        </div>
                        {/* <small className="text-muted subheader text-sm">
                          If it's enabled,this organization's all users will be disabled from logging in.
                        </small> */}
                      </Col>
                    </Row>
                    <Row>
                      <Col md={12}>
                        <h5 className="fw-bold">ADDRESS</h5>
                        <small className="text-muted subheader text-sm">
                          This address will be used for all official
                          correspondence with your organization.
                        </small>
                      </Col>
                    </Row>
                    <Row className="pt-3">
                      <Col>
                        <FormGroup>
                          <Row>
                            <Col md={6}>
                              <Col md={12}>
                                <Label>Address line1</Label>
                              </Col>
                              <Col md={12}>
                                <p>
                                  {organisationDetails.address.addressLine1 || "NA"}
                                </p>
                              </Col>
                            </Col>
                            <Col md={6}>
                              <Col md={12}>
                                <Label>Address line2</Label>
                              </Col>
                              <Col md={12}>
                                <p>
                                  {organisationDetails.address.addressLine2 || "NA"}
                                </p>
                              </Col>
                            </Col>
                          </Row>
                          <Row>
                            <Col md={6}>
                              <Col md={12}>
                                <Label>City</Label>
                              </Col>
                              <Col md={12}>
                                <p>{organisationDetails.address.city || "NA"}</p>
                              </Col>
                            </Col>
                            <Col md={6}>
                              <Col md={12}>
                                <Label>State</Label>
                              </Col>
                              <Col md={12}>
                                <p>{organisationDetails.address.state || "NA"}</p>
                              </Col>
                            </Col>
                          </Row>
                          <Row>
                            <Col md={6}>
                              <Col md={12}>
                                <Label>Country</Label>
                              </Col>
                              <Col md={12}>
                                <p>{organisationDetails.address.country || "NA"}</p>
                              </Col>
                            </Col>
                            <Col md={6}>
                              <Col md={12}>
                                <Label>Pincode</Label>
                              </Col>
                              <Col md={12}>
                                <p>{organisationDetails.address.pincode || "NA"}</p>
                              </Col>
                            </Col>
                          </Row>
                        </FormGroup>
                      </Col>
                    </Row>
                  </CardBody>
                </Card>
              </Col>
            </Row>
          )
        )}
        {/* </ContentWrapper> */}
        <VWModel
          header="EDIT ORGANIZATION"
          isOpen={isEditOrganisationModalOpen}
          modalSize='large'
          handleClose={handleCloseEditOrganisationModal}
        >
          <EditOrganisation handleClose={handleCloseEditOrganisationModal} />
        </VWModel>
      </div >
    </Fragment >
  );
}

const mapStateToProps = (state) => ({
  organisationDetails: state.organisationDetails.organisation,
  errorMessage: state.organisationDetails.OrgDetailsErrorMessage,
  isGetOrganisatonDetailsPending: state.organisationDetails.isGetOrganisationDetailsPending,
  isEditOrganisationModalOpen: state.organisationDetails.isEditOrganisationModalOpen,
});

const mapDispatchToProps = (dispatch) => ({
  getOrganisationDetails: (organisationId) => dispatch(getOrganisationDetails(organisationId)),
  closeEditOrganisationModal: () => dispatch(closeEditOrganisationModal()),
  openEditOrganisationModal: () => dispatch(openEditOrganisationModal()),
});

export default connect(mapStateToProps, mapDispatchToProps)(OrganisationDetails);
